<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="发货单异常剔除"
      width="600px"
      top="10vh"
      append-to-body
      @close="$reset('form')">
    <el-form ref="form" :model="form" :rules="ruleValidate" label-width="100px">
      <el-form-item label="发货单号" prop="deliveryNos">
        <el-input
            v-model="form.deliveryNos"
            type="textarea"
            :rows="8"
            placeholder="每行一个发货单号，可批量粘贴"/>
      </el-form-item>
      <el-form-item label="剔除原因" prop="reason">
        <el-input v-model="form.reason" type="textarea" :rows="2" placeholder="请输入剔除原因"/>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible=false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">提交剔除</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    name: "ExcludeImportDialog",
    data() {
      return {
        dialogVisible: false,
        submitLoading: false,
        form: {
          deliveryNos: "",
          reason: "",
        },
        ruleValidate: {
          deliveryNos: {required: true, message: "请填写发货单号", trigger: "blur"},
          reason: {required: true, message: "请填写剔除原因", trigger: "blur"},
        },
      };
    },
    methods: {
      open() {
        this.form.deliveryNos = "";
        this.form.reason = "";
        this.dialogVisible = true;
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (!valid) {
            return;
          }
          // 按换行切分为数组，过滤空行
          let nos = this.form.deliveryNos.split(/\r?\n/).map(s => s.trim()).filter(s => s !== "");
          if (nos.length === 0) {
            return this.$message.error("请填写发货单号");
          }
          this.submitLoading = true;
          // body 传数组，reason 走 query 参数
          this.$http
            .post("basic", "sd/salesRevenueReport/importExclude", nos, {reason: this.form.reason})
            .then(resp => {
              this.submitLoading = false;
              if (resp && resp.success === false) {
                return this.$message.error(resp.message || "提交失败");
              }
              this.dialogVisible = false;
              this.$message.success("剔除成功，共 " + nos.length + " 条");
              this.$emit("save-success");
            })
            .catch(() => {
              this.submitLoading = false;
            });
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
